import React, {useEffect, useState} from 'react';

import {db} from "../firebase/firebase";
import {useAuth} from "../contexts/authContext";
import {
    ArrowLeftIcon,
    ArrowRightIcon,
    ClockIcon,
    EnvelopeIcon, LinkIcon,
    PlusCircleIcon,
    TrashIcon, TruckIcon,
    UserIcon,
    XCircleIcon
} from "@heroicons/react/24/outline";
import {
    Button,
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle,
    Select,
} from "@headlessui/react";
import fipsCode from '../JSONS/fipCodes.json';
import AddressInput from "./CustomerForm/AddressInput";
import {useDarkMode} from "../contexts/darkModeContext";
import FireworksEffect from "./Widgets/FireworksEffect";
import {Link} from "react-router-dom";
import {collection, doc, getDocs, updateDoc, increment} from "firebase/firestore";
import {useNotification} from "./Notifications/NotificationProvider";
import {countryMapping, regionMapping, stateMapping} from "./GLOBAL/GlobalFunctions";

import course from "../PFC_Images/course.jpg"
import warehouse from "../PFC_Images/PFCWarehouse.JPG";

import logo from "../PFC_Images/PFC46.png";

import GolfThree from "./NewCustomerHeroSections/GolfThree";
import FloatingInput from "./InputComponents/FloatingInput";
import FormDivider from "./Widgets/FormDivider";
import FloatingSelect from "./InputComponents/FloatingSelect";
import FloatingTextArea from "./InputComponents/FloatingTextArea";
import SegmentedBoolean from "./InputComponents/SegementedBoolean";
import CustomButton from "./Widgets/CustomButton";
import GolfOne from "./NewCustomerHeroSections/GolfOne";
import GolfTwo from "./NewCustomerHeroSections/GolfTwo";
import GolfCarousel from "./CustomerForm/GolfCarousel";
import FormSubtext from "./Widgets/FormSubtext";
import {ChevronDownIcon} from "@heroicons/react/16/solid";

const NewCustomer = () => {

    const { currentUser } = useAuth();
    
    const [selectSales, setSelectSales] = useState(!currentUser);
    
    const [alertsOn] = useState(() => {
        const storedSettings = localStorage.getItem('alertsOn');
        return storedSettings ? JSON.parse(storedSettings).alertsOn : false; // Default to false if null
    });
    
    const [showFireworks, setShowFireworks] = useState(false)
    
    const { darkMode } = useDarkMode();
    const { triggerNotification } = useNotification();
    
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isClearing, setIsClearing] = useState(false);

    // eslint-disable-next-line no-unused-vars
    const [date, setDate] = useState("");

    const [fullname, setFullname] = useState("");
    const [salesCode, setSalesCode] = useState("");
    const [salesEmail, setSalesEmail] = useState("");
    const [salesID, setSalesID] = useState("");


    // MAIN DATA POINTS
    const [name, setName] = useState("");
    const [managementName, setManagementName] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [city, setCity] = useState("");
    const [selectedState, setSelectedState] = useState('NJ'); // Preselect NJ
    const [zip, setZip] = useState("");
    const [selectedCounty, setSelectedCounty] = useState('');
    const [fips, setFips] = useState("");
    const [country, setCountry] = useState("United States");
    const [industry, setIndustry] = useState("");


    // CONTACTS DATA POINTS
    const [contact, setContact] = useState("");
    const [contactPosition, setContactPosition] = useState("");
    const [contactPhone, setContactPhone] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const [billingContact, setBillingContact] = useState("");
    const [billingPhone, setBillingPhone] = useState("");
    const [invoiceEmails, setInvoiceEmails] = useState("");
    const [statementEmails, setStatementEmails] = useState("");

    const [website, setWebsite] = useState("");


    // SHIPPING DATA POINTS
    const [shippingAddress, setShippingAddress] = useState([]);


    // TAXES DATA POINTS
    const [taxID, setTaxID] = useState("");
    const [salesTaxStatus, setSalesTaxStatus] = useState("");
    const [taxExempCode, setTaxExempCode] = useState("");


    // PAYMENT DATA POINTS
    const [paymentType, setPaymentType] = useState("");
    
    // DELIVERY DATA POINTS
    const [TTA, setTTA] = useState(false);
    const [LAS, setLAS] = useState(false);
    const [LDA, setLDA] = useState(false);
    const [PJR, setPJR] = useState(false);
    const [DAR, setDAR] = useState(false);
    const [HSA, setHSA] = useState(false);
    const [FLC, setFLC] = useState(false);
    const [RPY, setRPY] = useState(false);
    
    const [deliveryInstructions, setDeliveryInstructions] = useState("");
    
    
    useEffect(() => {
      console.log("✅ shippingAddress has been updated:", shippingAddress);
    }, [shippingAddress]);
    
    
    const handleStateChange = (event) => {
        const stateCode = event.target.value;
        setSelectedState(stateCode);
        setSelectedCounty(''); // Reset county selection when state changes
    };

    const handleCountyChange = (event) => {
        const countyName = event.target.value;
        setSelectedCounty(countyName);

        // Find the selected county's data based on the selected county name
        const countyData = filteredCounties.find(county => county.county === countyName);

        // Set the fips code if county data exists, otherwise set it to an empty string
        if (countyData) {
            setFips(countyData.fips);
        } else {
            setFips("");  // Handle case where no county is selected or found
        }
    };

    // Filter counties based on the selected state
    const filteredCounties = fipsCode.county.filter(county => county.state === selectedState);

    const formatFipsCode = (fips) => {
        if (fips.length === 5) {
            return `${fips.slice(0, 2)}-${fips.slice(2)}`;
        }
        return fips;
    };
    
    const [users, setUsers] = useState([]);
    
    // eslint-disable-next-line no-unused-vars
    const [selectedRep, setSelectedRep] = useState(null);
    
    const handleSelectChange = (event) => {
        const selectedUser = event.target.value ? JSON.parse(event.target.value) : null;
    
        if (selectedUser) {
            setSelectedRep(selectedUser);
            setFullname(selectedUser.salesRep || "");
            setSalesCode(selectedUser.salesCode || "");
            setSalesEmail(selectedUser.salesEmail || "");
            setSalesID(selectedUser.salesID || "");
        } else {
            setSelectedRep(null);
            setFullname("");
            setSalesCode("");
            setSalesEmail("");
            setSalesID("");
        }
    };

    useEffect(() => {
        if (!currentUser) {
            if(salesID){
                setSelectSales(false);
            } else {
                setSelectSales(true);
            }
        }
        // eslint-disable-next-line
    }, [selectSales]);
    
    // Fetch users from Firestore on component mount
    useEffect(() => {
        const fetchUsers = async () => {
            const usersCollection = collection(db, 'Users');
            const userSnapshot = await getDocs(usersCollection);
            const userList = userSnapshot.docs.map(doc => ({
                salesID: doc.id, // UID from Firestore document ID
                salesRep: `${doc.data().fname} ${doc.data().lname}`, // Combining fname and lname into a single name field
                accountLevel: doc.data().accountLevel,
                salesEmail: doc.data().email,
                salesCode: doc.data().salesCode,
                
                
                profileImageUrl: doc.data().profileImageUrl,
                region: doc.data().region,
            }));
            setUsers(userList);
        };
        fetchUsers();
    }, []);

    useEffect(() => {
        
        const fetchUserName = async () => {
            if (currentUser) {
                try {
                    // Check if user data is in localStorage
                    const storedUserData = localStorage.getItem(`userData_${currentUser.uid}`);

                    if (storedUserData) {
                        // Use the stored user data
                        const userData = JSON.parse(storedUserData);
                        setSalesCode(userData.salesCode);
                        setSalesEmail(userData.email);
                        setSalesID(userData.id);

                        setFullname(userData.fname + " " + userData.lname);
                    } else {
                        // Fetch user document from Firestore based on the current user's UID
                        const userDoc = await db.collection('Users').doc(currentUser.uid).get();
                        if (userDoc.exists) {
                            // Get the user's name from the document data
                            const userData = userDoc.data();
                            setSalesCode(userData.salesCode);
                            setSalesEmail(userData.email);
                            setSalesID(userData.id);

                            setFullname(userData.fname + " " + userData.lname);

                            // Save user data to localStorage
                            localStorage.setItem(`userData_${currentUser.uid}`, JSON.stringify(userData));
                        } else {
                            console.log('User document not found');
                        }
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                }
            }
        };

        fetchUserName();
    }, [currentUser]);
    
    
    const onSubmitMain = async (e) => {
        e.preventDefault();

        console.log("Sales ID", salesID ?? currentUser?.uid);
        console.log("Sales Rep", fullname);
        console.log("Sales Code", salesCode);
        
        const collectionRef = db.collection("Customers").doc(salesID ?? currentUser?.uid).collection("pending");

        const parsedFormData = {

            // Sales Info
            salesRep: fullname,
            salesCode: salesCode,
            salesID: salesID ?? currentUser?.uid,
            status: "pending",
            salesEmail: salesEmail,
            
            submittedTime: Date.now(),
            
            // submittedTime: Date.now(),

            // Main
            name: name,
            managementName: managementName,
            address1: address1,
            address2: address2,
            city: city,
            state: selectedState, // Using selectedState for state
            zip: zip,
            county: selectedCounty, // Using selectedCounty for county
            fips: fips,
            country: country,
            industry: industry,

            // Contacts
            contact: contact,
            contactPosition: contactPosition,
            contactPhone: contactPhone,
            contactEmail: contactEmail,
            billingContact: billingContact,
            billingPhone: billingPhone,
            invoiceEmails: invoiceEmails,
            statementEmails: statementEmails,
            website: website,

            // Shipping
            ShippingAddresses: shippingAddress,

            // Finances
            taxID: taxID,
            salesTaxStatus: salesTaxStatus,
            taxExempCode: taxExempCode,
            paymentType: paymentType,

            // Delivery
            TTA: TTA,
            LAS: LAS,
            LDA: LDA,
            PJR: PJR,
            DAR: DAR,
            HSA: HSA,
            FLC: FLC,
            RPY: RPY,
            deliveryInstructions: deliveryInstructions,


        };

        
        try {
            await collectionRef.add(parsedFormData);
            
            // Increment the counter in GlobalSettings/NewCustomers
            const docRef = doc(db, "GlobalSettings", "NewCustomers");
            await updateDoc(docRef, {
                count: increment(1)
            });
            
            localStorage.setItem('newCustomer', 'true');
            if (alertsOn) {
                alert(`Customer Added to the Cloud`); // Optional: alert for user feedback
            }
            
            setShowFireworks(true);
            setIsSubmitting(false);
            clearAllFields();
            setTimeout(() => setShowFireworks(false), 5000) // Hide fireworks after 3 seconds
            
            triggerNotification("newCustAdded");
            
        } catch (error) {
             console.error('Error registering client:', error.message);
             triggerNotification("newCustAddedError");
             // setIsRegistered(false);
        }
        
        
    };
    
    
    const handleAddComponent = () => {
        const newId = shippingAddress.length + Math.random(); // Create a unique id for each new address
        setShippingAddress([...shippingAddress, { id: newId }]); // Add a new address with its unique id
    };

    // Function to remove an address input component based on ID
    const handleRemoveComponent = (idToRemove) => {
        setShippingAddress(shippingAddress.filter(item => item.id !== idToRemove)); // Remove the item with the matching id
    };

    // Function to handle input changes from child components
    const handleAddressChange = (index, updatedAddress) => {
        const updatedAddresses = [...shippingAddress];
        updatedAddresses[index] = { ...updatedAddresses[index], ...updatedAddress }; // Ensure we maintain other properties like id
        setShippingAddress(updatedAddresses);
    };



    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent form submission on Enter
            // handleNextTab(); // Navigate to the next tab
        }
    };

    // fetch time and date
    useEffect(() => {
        const fetchWeather = async () => {
            // Get current time

            // Get current date
            const currentDate = new Date().toLocaleDateString();
            setDate(currentDate);
        };

        fetchWeather();
    }, []);

    
    const clearAllFields = () => {
        setName("");
        setManagementName("");
        setAddress1("");
        setAddress2("");
        setCity("");
        setSelectedState("NJ"); // Reset to default "NJ"
        setZip("");
        setSelectedCounty("");
        setFips("");
        setCountry("United States"); // Reset to default
        setIndustry("");
    
        setContact("");
        setContactPosition("");
        setContactPhone("");
        setContactEmail("");
        setBillingContact("");
        setBillingPhone("");
        setInvoiceEmails("");
        setStatementEmails("");
    
        setWebsite("");
    
        setShippingAddress([]); // Reset to an empty array
    
        setTaxID("");
        setSalesTaxStatus("");
        setTaxExempCode("");
    
        setPaymentType("");
    
        setTTA(false);
        setLAS(false);
        setLDA(false);
        setPJR(false);
        setDAR(false);
        setHSA(false);
        setFLC(false);
        setRPY(false);
        setDeliveryInstructions("");
        
        setIsClearing(false);
    };
    
   
    return (
        <div className={`relative bg-black flex w-full ${currentUser ? 'h-[calc(100dvh-3.5rem)] p-10' : 'h-dvh p-16'} transition-all duration-500 ease-in-out`}>
            
            <img
                src={course}
                alt="background"
                className="absolute opacity-80 inset-0 w-full h-full object-cover"
            />
            
            {/*Redesign*/}
            <div className={`animate-expandIn grid grid-cols-2 bg-white overflow-hidden w-full divide-x-2 h-full z-50 rounded-2xl drop-shadow-2xl`}>
            
                {/*Form*/}
                <div className={`col-span-1 ${currentUser ? 'h-[calc(100dvh-9rem)]' : 'h-[calc(100dvh-8rem)]'} p-4 space-y-4 overflow-y-scroll scrollbar-hide`}>
                    
                    {/*Plant Food Header*/}
                    <div className={`flex items-center justify-between`}>
                        
                        <div className={`flex gap-x-4 items-center`}>
                            <img
                                src={logo}
                                className={`size-24 w-fit`}
                                alt={``}
                            />
                            
                            <div className={`flex flex-col`}>
                                <span className={`text-3xl text-black`}>Plant Food Company Inc.</span>
                                <span className={`-mt-2 text-sm text-gray-500`}>New Customer Onboarding Form</span>
                            </div>
                        
                        </div>
                        
                        
                    </div>
                    
                    <form onSubmit={onSubmitMain} method="POST" onKeyDown={handleKeyDown}
                          className="h-full w-full flex flex-col justify-between">
                        
                        {/*Form Grid*/}
                        <div className="grid grid-cols-6 gap-x-4 gap-y-6 w-full">
                            
                            <FormDivider label={`Customer Information`}/>
                            
                            {/*Name*/}
                            <div className={`relative col-span-3`}>
                                
                                <FloatingInput
                                    label="Company Name"
                                    required={true}
                                    placeholder="Enter Company Name..."
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*Management Name*/}
                            <div className={`relative col-span-3`}>
                                
                                <FloatingInput
                                    label="Management Group Name"
                                    required={false}
                                    placeholder="Enter Management Name..."
                                    value={managementName}
                                    onChange={(e) => setManagementName(e.target.value)}
                                />
                                
                            </div>
                            
                            
                            <FormDivider label={`Contact Information`}/>
                            
                            
                            {/*Contact Name*/}
                            <div className={`relative col-span-3`}>
                                
                                <FloatingInput
                                    label="Contact Name"
                                    required={true}
                                    placeholder="Enter Contact Name..."
                                    value={contact}
                                    onChange={(e) => setContact(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*Position*/}
                            <div className={`relative col-span-3`}>
                                
                                <FloatingInput
                                    label="Contact Position"
                                    required={false}
                                    placeholder="Enter Contact Position..."
                                    value={contactPosition}
                                    onChange={(e) => setContactPosition(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*Contact Phone*/}
                            <div className={`relative col-span-full`}>
                                
                                <FloatingInput
                                    label="Contact Phone"
                                    required={true}
                                    placeholder="Enter Phone Number..."
                                    value={contactPhone}
                                    onChange={(e) => setContactPhone(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*Contact Email*/}
                            <div className={`relative col-span-3`}>
                                
                                <FloatingInput
                                    label="Contact Email"
                                    required={false}
                                    placeholder="Enter Contact Email..."
                                    value={contactEmail}
                                    onChange={(e) => setContactEmail(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*Website*/}
                            <div className={`relative col-span-3`}>
                                
                                <FloatingInput
                                    label="Website"
                                    required={false}
                                    placeholder="Enter URL..."
                                    value={website}
                                    onChange={(e) => setWebsite(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*Industry*/}
                            <div className={`relative col-span-full`}>
                                
                                <FloatingSelect
                                    label="Industry"
                                    value={industry}
                                    onChange={(e) => setIndustry(e.target.value)}
                                    required={true}
                                >
                                    <option value="">Select Industry...</option>
                                    <option value="BOTANICAL">Botanical Garden</option>
                                    <option value="DISTRIB">Product Distributor</option>
                                    <option value="FARM">Agriculture - Farm</option>
                                    <option value="GOLF">Golf Course</option>
                                    <option value="GOVERNMENT">Government Entity</option>
                                    <option value="INDUSTRIAL">Industrial</option>
                                    <option value="LAWNTREE">Lawn Care & Tree Care</option>
                                    <option value="MRSALE">One Time Purchase Expected</option>
                                    <option value="MUNICIPAL">Municipal / School</option>
                                    <option value="Non-Profit">Non-Profit Account</option>
                                    <option value="SPORTFLD">Sportsfield</option>
                                    <option value="OTHER">Other</option>
                                </FloatingSelect>
                            
                            </div>
                            
                            
                            <FormDivider label={`Billing Information`}/>
                            
                            
                            {/*Address 1*/}
                            <div className={`relative col-span-full`}>
                                
                                <FloatingInput
                                    label="Address [1]"
                                    required={true}
                                    placeholder="Street Address 1..."
                                    value={address1}
                                    onChange={(e) => setAddress1(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*Address 2*/}
                            <div className={`relative col-span-full`}>
                                
                                <FloatingInput
                                    label="Address [2]"
                                    required={false}
                                    placeholder="Optional..."
                                    value={address2}
                                    onChange={(e) => setAddress2(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*City*/}
                            <div className={`relative col-span-2`}>
                                
                                <FloatingInput
                                    label="City"
                                    required={true}
                                    placeholder="Enter City..."
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*State*/}
                            <div className={`relative col-span-2`}>
                                
                                <FloatingSelect
                                    label="State"
                                    value={selectedState}
                                    onChange={handleStateChange}
                                    required={country === "United States"}
                                >
                                    {Object.entries(stateMapping).map(([abbr, name]) => (
                                        <option key={abbr} value={abbr}>
                                          {name}
                                        </option>
                                    ))}
                                </FloatingSelect>
                                
                            </div>
                            
                            {/*ZipCode*/}
                            <div className={`relative col-span-2`}>
                                
                                <FloatingInput
                                    label="Zip Code"
                                    required={country === "United States"}
                                    placeholder="Enter Zip Code..."
                                    value={zip}
                                    onChange={(e) => setZip(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*County*/}
                            <div className={`relative col-span-4`}>
                                
                                <FloatingSelect
                                    label="County"
                                    value={selectedCounty}
                                    onChange={handleCountyChange}
                                    required={country === "United States"}
                                >
                                    <option value="">Select a County...</option>
                                    {filteredCounties.map(county => (
                                        <option key={county.fips} value={county.county}>{county.county}</option>
                                    ))}
                                </FloatingSelect>
                                
                            </div>
                            
                            {/*Fips Code*/}
                            <div className={`relative col-span-2`}>
                                
                                <FloatingInput
                                    label="Fips Code"
                                    required={country === "United States"}
                                    disabled={true}
                                    placeholder="Fips Code..."
                                    value={formatFipsCode(fips)}
                                />
                                
                            </div>
                            
                            {/*Country*/}
                            <div className={`relative col-span-full`}>
                                
                                <FloatingSelect
                                    label="Country"
                                    value={country}
                                    onChange={(e) => setCountry(e.target.value)}
                                    required={true}
                                >
                                    {Object.entries(countryMapping).map(([abbr, name]) => (
                                        <option key={abbr} value={abbr}>
                                          {name}
                                        </option>
                                    ))}
                                </FloatingSelect>
                                
                            </div>
                            
                            
                            <FormDivider label={`Financial`}/>
                            
                            
                            {/*TaxID*/}
                            <div className={`relative col-span-full`}>
                                
                                <FloatingInput
                                    label="Tax ID#"
                                    required={false}
                                    placeholder="Enter Tax ID#..."
                                    value={taxID}
                                    onChange={(e) => setTaxID(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*Sales Tax Status*/}
                            <div className={`relative col-span-3`}>
                                
                                <FloatingSelect
                                    label="Sales Tax Status"
                                    value={salesTaxStatus}
                                    onChange={(e) => setSalesTaxStatus(e.target.value)}
                                    required={true}
                                >
                                    <option value="">Select a status option...</option>
                                    <option value="Taxable">Taxable</option>
                                    <option value="Tax Exempt">Tax Exempt</option>
                                </FloatingSelect>
                            
                            </div>
                            
                            {/*Email*/}
                            <div className={`relative h-full col-span-3 flex flex-col items-end justify-center text-xs italic text-gray-500`}>
                                <span className={``}>If Tax Exempt, please email Tax Exemption Certification to:</span>
                                <a
                                    href={`mailto:accountingAR@plantfoodco.com`}
                                    className="flex items-center hover:text-green-600 font-bold"
                                >
                                    <EnvelopeIcon className="size-5 mr-1"/>
                                    <span className={`font-bold`}>accountingAR@plantfoodco.com</span>
                                </a>
                            </div>
                            
                            {/*Tax Exemption Code*/}
                            <div className={`relative col-span-3`}>
                                
                                <FloatingInput
                                    label="Tax Excemption Code"
                                    required={false}
                                    placeholder="Optional..."
                                    value={taxExempCode}
                                    onChange={(e) => setTaxExempCode(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*Payment Type*/}
                            <div className={`relative col-span-3`}>
                                
                                <FloatingSelect
                                    label="Prefered Payment Type"
                                    value={paymentType}
                                    onChange={(e) => setPaymentType(e.target.value)}
                                    required={true}
                                >
                                    <option value="">Select a Payment Option...</option>
                                    <option value="Check">Check</option>
                                    <option value="ACH">ACH / Wire</option>
                                    <option value="Credit">Credit Card (3% Service Fee)</option>
                                </FloatingSelect>
                            
                            </div>
                            

                            <FormDivider label={`Billing Contacts`}/>
                            
                            
                            {/*Billing Name*/}
                            <div className={`relative col-span-full`}>
                                
                                <FloatingInput
                                    label="Billing Contact"
                                    required={true}
                                    placeholder="Enter Billing Contact Name..."
                                    value={billingContact}
                                    onChange={(e) => setBillingContact(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*Billing Phone*/}
                            <div className={`relative col-span-full`}>
                                
                                <FloatingInput
                                    label="Billing Phone"
                                    required={true}
                                    placeholder="Enter Billing Phone..."
                                    value={billingPhone}
                                    onChange={(e) => setBillingPhone(e.target.value)}
                                />
                                
                            </div>
                            
                            
                            <FormDivider label={`Invoice & Statements`}/>
                            <FormSubtext label={`Invoices & Statements will be e-mailed to the addresses provided. You may include multiple email addresses by separating them with a semi colon`}/>
                            
                            
                            {/*Invoice Email*/}
                            <div className={`relative col-span-full`}>
                                
                                <FloatingInput
                                    label="Invoice Email"
                                    required={true}
                                    placeholder="Enter Invoice Email.."
                                    value={invoiceEmails}
                                    onChange={(e) => setInvoiceEmails(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*Statement Email*/}
                            <div className={`relative col-span-full`}>
                                
                                <FloatingInput
                                    label="Statements Email"
                                    required={true}
                                    placeholder="Enter Statements Email..."
                                    value={statementEmails}
                                    onChange={(e) => setStatementEmails(e.target.value)}
                                />
                                
                            </div>
                            
                            
                            {/*Shipping Header*/}
                            <div className="text-black py-4 sm:col-span-full relative justify-center items-center font-semibold uppercase flex">
                               
                                <div className="relative flex justify-start w-fit">
                                    <span className={`${darkMode ? 'bg-bgDark' : 'bg-white'} pr-3 text-base font-semibold italic whitespace-nowrap`}>Shipping Locations {shippingAddress.length}</span>
                                </div>
                                
                                <div aria-hidden="true" className={`w-full border-t-2 border-gray-300`}/>
                                
                                <div className={`w-fit whitespace-nowrap pl-2`}>
                                    <CustomButton
                                        color={`green`}
                                        onClick={handleAddComponent}
                                        icon={PlusCircleIcon}
                                        text={`Add Location`}
                                    />
                                </div>
                                
                            </div>
                            
                            
                            {/*Shipping Map*/}
                            <div className={`text-black col-span-full w-full h-full rounded-lg px-4 `}>

                                <div className={`scrollbar-hide rounded-lg scroll overflow-y-auto overflow-x-hidden space-y-4`}>
                                    {shippingAddress.length === 0 ? (
                                        // Display custom dialog if sprays array is empty
                                        
                                        <div className="flex w-full h-full justify-center items-center py-10">
                                            
                                            <div className="rounded-md shadow-gray-900 flex items-center justify-center flex-col m-2">
                                               
                                                <div className={`size-24 bg-gray-500/15 flex items-center justify-center rounded-full`}>
                                                    <TruckIcon className="size-16 text-gray-500/50"/>
                                                </div>
                                                
                                                <p className="text-xl line-clamp-1 flex font-semibold">No Shipping Locations</p>
                                                <p className="text-xs flex text-gray-500 italic">You may add in multiple shipping locations</p>
                                                <div className="mt-4">
                                                    <CustomButton
                                                        color={`green`}
                                                        onClick={handleAddComponent}
                                                        icon={PlusCircleIcon}
                                                        text={`Add Location`}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        
                                    ) : (
                                        // Display SprayCard components if sprays array is not empty
                                        shippingAddress.map((item, index) => (
                                            <AddressInput
                                                id={item.id}
                                                key={item.id}
                                                index={index}
                                                item={item}
                                                darkMode={false}
                                                
                                                Eaddress1={address1}
                                                Eaddress2={address2}
                                                Ecity={city}
                                                Estate={selectedState}
                                                Ezip={zip}
                                                Ecounty={selectedCounty}
                                                Efips={fips}
                                                
                                                onChange={handleAddressChange}
                                                onRemove={handleRemoveComponent}
                                            />
                                        ))
                                    )}
                                </div>

                            </div>
                            
                            
                            {/*-------*/}
                            
                            <FormDivider label={`Delivery`}/>
                            
                            {/*Delivery Questions*/}
                            <div className={`col-span-full flex flex-col w-full border-2 rounded-lg overflow-hidden`}>

                                {/*Label*/}
                                <div className={`grid items-center grid-cols-3 w-full border-b-2 p-3 bg-black/5`}>
                                    <div className="col-span-2 text-black ">Delivery Questions?</div>
                                    
                                    <div className="hidden col-span-1 text-center font-semibold text-gray-500 text-xs grid grid-cols-2 bg-black/5 p-1 gap-x-1 rounded-lg">
                                        <span className={`bg-white rounded-md py-1.5`}>NO</span>
                                        <span className={`bg-white rounded-md py-1.5`}>YES</span>
                                    </div>
                                </div>
                                
                                {/*Field Grid*/}
                                <div className={`text-black py-4 grid grid-cols-1 gap-x-3 gap-y-3 px-4`}>
                                    
                                    {/*TTA*/}
                                    <div className={`col-span-full grid grid-cols-3 gap-x-3`}>
                                        <div className={`col-span-2 flex flex-col border-b-2 `}>
                                            <span className={`text-sm`}>Tractor Trailer Accessible?</span>
                                            <span className={`text-xs text-gray-500 italic`}>{TTA ? 'Yes this site is accessible' : 'This site is not accessible'}</span>
                                        </div>
                                        <div className={`col-span-1 flex items-center justify-center`}>
                                            
                                            <SegmentedBoolean
                                                value={TTA}
                                                trueLabel="YES"
                                                falseLabel="NO"
                                                onChange={setTTA}
                                            />
                                            
                                        </div>
                                    </div>
                                    
                                    {/*LAS*/}
                                    <div className={`col-span-full grid grid-cols-3 gap-x-3`}>
                                        <div className={`col-span-2 flex flex-col border-b-2 `}>
                                            <span className={`text-sm`}>Limited Access Site?</span>
                                            <span className={`text-xs text-gray-500 italic`}>{LAS ? 'Yes this site does have limited Access' : 'This site does not have limited access'}</span>
                                        </div>
                                        <div className={`col-span-1 flex items-center justify-center`}>
                                            
                                            <SegmentedBoolean
                                                value={LAS}
                                                trueLabel="YES"
                                                falseLabel="NO"
                                                onChange={setLAS}
                                            />
                                            
                                        </div>
                                    </div>
                                    
                                    {/*LDA*/}
                                    <div className={`col-span-full grid grid-cols-3 gap-x-3`}>
                                        <div className={`col-span-2 flex flex-col border-b-2 `}>
                                            <span className={`text-sm`}>Loading Dock Available?</span>
                                            <span className={`text-xs text-gray-500 italic`}>{LDA ? 'Yes this site does have a loading dock' : 'This site does not have a loading dock'}</span>
                                        </div>
                                        
                                        <div className={`col-span-1 flex items-center justify-center`}>
                                            
                                            <SegmentedBoolean
                                                value={LDA}
                                                trueLabel="YES"
                                                falseLabel="NO"
                                                onChange={setLDA}
                                            />
                                            
                                        </div>
                                    </div>
                                    
                                    {/*PJR*/}
                                    <div className={`col-span-full grid grid-cols-3 gap-x-3`}>
                                        
                                        <div className={`col-span-2 flex flex-col border-b-2 `}>
                                            <span className={`text-sm`}>Lift Gate & Pallet Jack Required?</span>
                                            <span className={`text-xs text-gray-500 italic`}>{PJR ? 'A Pallet Jack and Lift Gate are needed' : 'Equipment not needed'}</span>
                                        </div>
                                        
                                        <div className={`col-span-1 flex items-center justify-center`}>
                                            
                                            <SegmentedBoolean
                                                value={PJR}
                                                trueLabel="YES"
                                                falseLabel="NO"
                                                onChange={setPJR}
                                            />
                                            
                                        </div>
                                    </div>
                                    
                                    {/*DAR*/}
                                    <div className={`col-span-full grid grid-cols-3 gap-x-3`}>
                                       
                                        <div className={`col-span-2 flex flex-col border-b-2 `}>
                                            <span className={`text-sm`}>Delivery Appointment Required?</span>
                                            <span className={`text-xs text-gray-500 italic`}>{DAR ? 'Driver must call ahead of deliveries' : 'Appointment not necessary'}</span>
                                        </div>
                                        
                                        <div className={`col-span-1 flex items-center justify-center`}>
                                            
                                            <SegmentedBoolean
                                                value={DAR}
                                                trueLabel="YES"
                                                falseLabel="NO"
                                                onChange={setDAR}
                                            />
                                            
                                        </div>
                                    </div>
                                    
                                    {/*HSA*/}
                                    <div className={`col-span-full grid grid-cols-3 gap-x-3`}>
                                        
                                        <div className={`col-span-2 flex flex-col border-b-2 `}>
                                            <span className={`text-sm`}>Heated Storage Available?</span>
                                            <span className={`text-xs text-gray-500 italic`}>{HSA ? 'Heated Storage is available for products' : 'Not Available'}</span>
                                        </div>
                                        
                                        <div className={`col-span-1 flex items-center justify-center`}>
                                            
                                            <SegmentedBoolean
                                                value={HSA}
                                                trueLabel="YES"
                                                falseLabel="NO"
                                                onChange={setHSA}
                                            />
                                        </div>
                                    </div>
                                    
                                    {/*FLC*/}
                                    <div className={`col-span-full grid grid-cols-3 gap-x-3`}>
                                       
                                        <div className={`col-span-2 flex flex-col border-b-2 `}>
                                            <span className={`text-sm`}>Forklift Available w/ 3,000 lbs Capacity?</span>
                                            <span className={`text-xs text-gray-500 italic`}>{FLC ? 'A Forklift is available with specified capacity' : 'Forklift is either not available or not of specified capacity'}</span>
                                        </div>
                                        
                                        <div className={`col-span-1 flex items-center justify-center`}>
                                            
                                            <SegmentedBoolean
                                                value={FLC}
                                                trueLabel="YES"
                                                falseLabel="NO"
                                                onChange={setFLC}
                                            />
                                            
                                        </div>
                                    </div>
                                    
                                    {/*RPY*/}
                                    <div className={`col-span-full grid grid-cols-3 gap-x-3`}>
                                        
                                        <div className={`col-span-2 flex flex-col border-b-2 `}>
                                            <span className={`text-sm`}>Residential Property?</span>
                                            <span className={`text-xs text-gray-500 italic`}>{FLC ? 'Property is residential' : 'Property is not residential'}</span>
                                        </div>
                                        
                                        <div className={`col-span-1 flex items-center justify-center`}>
                                            
                                            <SegmentedBoolean
                                                value={RPY}
                                                trueLabel="YES"
                                                falseLabel="NO"
                                                onChange={setRPY}
                                            />
                                            
                                        </div>
                                    </div>
                                    
                                </div>
                                
                            </div>
                            
                            {/*Delivery Instructions*/}
                            <div className={`relative col-span-full`}>
                                
                                <FloatingTextArea
                                    label="Special Delivery Instructions"
                                    required={false}
                                    placeholder="Notes..."
                                    value={deliveryInstructions}
                                    onChange={(e) => setDeliveryInstructions(e.target.value)}
                                />
                                
                            </div>
                            
                            {/*Submit Button*/}
                            <div className={`pb-4 relative col-span-full flex items-center justify-center gap-x-4`}>
                                
                                <div className={`w-fit`}>
                                    
                                    <CustomButton
                                        color={`red`}
                                        onClick={() => setIsClearing(true)}
                                        icon={TrashIcon}
                                        text={`Clear Form`}
                                    />
                                    
                                </div>
                                
                                <div className={`w-full`}>
                                    
                                    <Button
                                        type="submit"
                                        className={`hover:bg-opacity-50 hover:scale-105 duration-500 w-full bg-green-600 italic text-sm text-white px-4 py-1 rounded`}
                                    >
                                        Submit Customer To Plant
                                    </Button>
                                    
                                </div>
                            </div>
                            
    
                        </div>
                        
                    </form>

                </div>
                
                {/*Showcase*/}
                <GolfCarousel/>
                
            </div>
            
            
            {showFireworks && <FireworksEffect show={showFireworks}/>}
            
            
            <Dialog open={isClearing} onClose={setIsClearing} className="relative z-50">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
        
              <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className={`relative transform overflow-hidden rounded-lg ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                  >
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-600/15 sm:mx-0 sm:size-10">
                        <XCircleIcon aria-hidden="true" className="size-6 text-red-600" />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <DialogTitle as="h3" className="text-base font-semibold">
                          Clear Customer Form
                        </DialogTitle>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            This function will clear all of the fields in the entire customer form. This action may not be undone and you may not recover your progress!
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                      <Button
                        type="button"
                        onClick={clearAllFields}
                        className={`inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto`}
                      >
                        Clear Form
                      </Button>
                      <Button
                        type="button"
                        data-autofocus
                        onClick={() => setIsClearing(false)}
                        className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                      >
                        Cancel
                      </Button>
                    </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>


            <Dialog open={selectSales} onClose={setSelectSales} className="relative z-50">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/40 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
        
              <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className={`relative transform overflow-hidden animate-expandIn rounded-lg bg-black text-black text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-6xl data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                    >
                        
                        <img
                            src={warehouse}
                            alt="background"
                            className="absolute opacity-70 inset-0 w-full h-full object-cover"
                        />
                        
                        {/*Header*/}
                        <div className={`z-50 backdrop-blur-sm text-white px-3 pt-3 flex justify-between items-center`}>
                            <div className={`flex flex-col space-y-2`}>
                                <div className={`z-50 flex gap-x-4 items-center`}>
                                    <img
                                        src={logo}
                                        className={`size-16 w-fit`}
                                        alt={``}
                                    />
                                    
                                    <div className={`z-50 flex flex-col`}>
                                        <span className={`text-2xl font-bold`}>Plant Food Company Inc.</span>
                                        <span className={`-mt-2 text-sm italic`}>Select Your Sales Rep</span>
                                    </div>
                                
                                </div>
                                
                                <span className={`z-50 text-xs italic`}>Choose a trusted professional from our team to support and manage your account.</span>
                            
                            </div>
                            
                            
                            <div className={`flex gap-x-2`}>
                                
                                <Link
                                    to={`/Customer`}
                                    type="button"
                                    data-autofocus
                                    className={`inline-flex w-full justify-center items-center rounded-md bg-red-600 px-2 gap-x-2 py-1 text-xs font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                                >
                                    <ArrowLeftIcon className={`size-4`}/>
                                    Return Home
                                </Link>
                                
                                <CustomButton
                                    color={`green`}
                                    onClick={() => setSelectSales(false)}
                                    icon={ArrowRightIcon}
                                    text={`Next`}
                                    flip={true}
                                />
                                
                            </div>
                            
                        </div>
                        
                        {/*Rep List*/}
                        <div className="relative z-50 grid grid-cols-3 overflow-y-scroll scrollbar-hide p-3 gap-2">
                            
                            <div className="col-span-full grid grid-cols-3 gap-4">

                                {/* NE Column */}
                                <div className="flex flex-col gap-2">
                                    
                                    <FormDivider label={`Northeast Turf & Ornamental`} className={`text-sm py-2`}/>
                            
                                    {users
                                      .filter(user => user.accountLevel === "S" && user.region === "NE")
                                      .sort((a, b) => a.salesRep.localeCompare(b.salesRep))
                                      .map(user => {
                                            const isSelected = selectedRep?.salesCode === user.salesCode;
                            
                                            return (
                                                <button
                                                    key={user.salesCode}
                                                    type="button"
                                                    onClick={() => handleSelectChange({
                                                        target: { value: JSON.stringify(user) }
                                                    })}
                                                    className={`
                                                        p-2 rounded-xl text-left transition-all duration-200
                                                        ${isSelected
                                                            ? 'border-green-600 bg-green-600 text-white'
                                                            : 'border-gray-300 bg-white hover:bg-gray-50 drop-shadow-xl'
                                                        }
                                                    `}
                                                >
                                                    <div className="flex gap-x-2">
                                                        <img
                                                            src={user.profileImageUrl || logo}
                                                            className="w-9 h-9 rounded-full object-cover"
                                                        />
                                                        <div className="flex flex-col">
                                                            <span className="text-sm font-medium">{user.salesRep}</span>
                                                            <span className="text-xs italic text-gray-500">{regionMapping[user.region]}</span>
                                                        </div>
                                                    </div>
                                                </button>
                                            );
                                        })}
                                </div>
                            
                                {/* SE + COM Column */}
                                <div className="flex flex-col gap-2">
                                    
                                    <FormDivider label={`Southeast Turf & Ornamental`} className={`text-sm py-2`}/>
                            
                                    {users
                                      .filter(user =>
                                        user.accountLevel === "S" &&
                                        (user.region === "SE" || user.region === "COM")
                                      )
                                      .sort((a, b) => a.salesRep.localeCompare(b.salesRep))
                                      .map(user => {
                                            const isSelected = selectedRep?.salesCode === user.salesCode;
                            
                                            return (
                                                <button
                                                    key={user.salesCode}
                                                    type="button"
                                                    onClick={() => handleSelectChange({
                                                        target: { value: JSON.stringify(user) }
                                                    })}
                                                    className={`
                                                        p-2 rounded-xl text-left transition-all duration-200
                                                        ${isSelected
                                                            ? 'border-green-600 bg-green-600 text-white'
                                                            : 'border-gray-300 bg-white hover:bg-gray-50 drop-shadow-xl'
                                                        }
                                                    `}
                                                >
                                                    <div className="flex gap-x-2">
                                                        <img
                                                            src={user.profileImageUrl || logo}
                                                            className="w-9 h-9 rounded-full object-cover"
                                                        />
                                                        <div className="flex flex-col">
                                                            <span className="text-sm font-medium">{user.salesRep}</span>
                                                            <span className="text-xs italic text-gray-500">
                                                                {regionMapping[user.region]}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </button>
                                            );
                                        })}
                                </div>
                                
                                {/* AG Column */}
                                <div className="flex flex-col gap-2">
                                    
                                    <FormDivider label={`Northeast Agriculture`} className={`text-sm py-2`}/>
                                    
                                    {users
                                      .filter(user => user.accountLevel === "S" && user.region === "AG")
                                      .sort((a, b) => a.salesRep.localeCompare(b.salesRep))
                                      .map(user => {
                                            const isSelected = selectedRep?.salesCode === user.salesCode;
                            
                                            return (
                                                <button
                                                    key={user.salesCode}
                                                    type="button"
                                                    onClick={() => handleSelectChange({
                                                        target: { value: JSON.stringify(user) }
                                                    })}
                                                    className={`
                                                        p-2 rounded-xl text-left transition-all duration-200
                                                        ${isSelected
                                                            ? 'border-green-600 bg-green-600 text-white'
                                                            : 'border-gray-300 bg-white hover:bg-gray-50 drop-shadow-xl'
                                                        }
                                                    `}
                                                >
                                                    <div className="flex gap-x-2">
                                                        <img
                                                            src={user.profileImageUrl || logo}
                                                            className="w-9 h-9 rounded-full object-cover"
                                                        />
                                                        <div className="flex flex-col">
                                                            <span className="text-sm font-medium">{user.salesRep}</span>
                                                            <span className="text-xs italic text-gray-500">{regionMapping[user.region]}</span>
                                                        </div>
                                                    </div>
                                                </button>
                                            );
                                        })}
                                </div>
                                
                            </div>
                        
                        </div>
                    
                        {/*Scroll Indicator*/}
                        <div className={`z-50 absolute bottom-2 right-2 flex items-center gap-x-2`}>
                            
                            <CustomButton
                                color={`green`}
                                onClick={() => {
                                    const defaultRep = {
                                        salesRep: "Grant Platz",
                                        salesCode: "GP",
                                        salesEmail: "gplatz@plantfoodco.com",
                                        salesID: "9nqTaGIMElcjmwQPtV3YncR0hzM2"
                                    };

                                    setSelectedRep(defaultRep);
                                    setFullname(defaultRep.salesRep);
                                    setSalesCode(defaultRep.salesCode);
                                    setSalesEmail(defaultRep.salesEmail);
                                    setSalesID(defaultRep.salesID);

                                    setSelectSales(false);
                                }}
                                text={`Sales Rep Unknown`}
                                icon={UserIcon}
                            />
                            
                            <div className={`bg-white/50 backdrop-blur-sm rounded-xl size-12 z-50 flex items-center justify-center`}>
                                <ChevronDownIcon className={`size-12 text-white`}/>
                            </div>
                        </div>
                        
                    
                    </DialogPanel>
                </div>
              </div>
            </Dialog>
        
        
        </div>
    )
};


export default NewCustomer;
